const agentTheme = {
    getAgentTheme: function (wid){
        let wsid = 35;

        if (wid!=null) wsid = wid;

        let themes = {
            w143:{
                id:143,
                colors:{
                    primary:{
                        base:"#bb0000",
                    },
                    secondary:{},
                },
                logo:{
                    url:"https://www.ar-pae.com/wp-content/uploads/2018/10/88.png",
                    aspectRatio:1,
                    mobileAspectRatio:1,
                    width:80,
                    height:80,
                    mobileWidth:45,
                    mobileHeight:45,  
                    text:"ARPAEDOTCOM",                  
                }            
            },
            w35:{
                id:35,
                colors:{
                    primary:{
                        base:"#0d4c75",
                    },
                    secondary:{},
                },
                logo:{
                    url:"https://i.imgur.com/vf4WSKD.png",
                    aspectRatio:30/20,
                    mobileAspectRatio:1,
                    width:150,
                    height:200,
                    mobileWidth:50,
                    mobileHeight:50,  
                    text:"GALILEO ONLINE",                    
                }            
            },  
            w94:{
                id:94,
                colors:{
                    primary:{
                        base:"#2b8ac7",
                    },
                    secondary:{},
                },
                logo:{
                    url:"https://i.imgur.com/JZXgLy4.png",
                    aspectRatio:371/58,
                    mobileAspectRatio:158/24,
                    width:371,
                    height:58,
                    mobileWidth:158,
                    mobileHeight:24,                     
                    text:" ",                    
                }            
            },  
            w176:{
                id:176,
                colors:{
                    primary:{
                        base:"#0d4c75",
                    },
                    secondary:{},
                },
                logo:{
                    url:"https://image.galileo.co.th/go_agencies/Genius/logo.jpg",
                    aspectRatio:150/100,
                    mobileAspectRatio:2/1,
                    width:150,
                    height:100,
                    mobileWidth:100,
                    mobileHeight:50,  
                    text:"",                     
                }            
            },   
            w21:{
                id:21,
                colors:{
                    primary:{
                        base:"#0d4c75",
                    },
                    secondary:{},
                },
                logo:{
                    url:"https://image.galileo.co.th/go_agencies/samuilook/logo.jpg",
                    aspectRatio:150/100,
                    mobileAspectRatio:2/1,
                    width:150,
                    height:100,
                    mobileWidth:100,
                    mobileHeight:50,  
                    text:"",                    
                }            
            },
			w54:{
                id:54,
                colors:{
                    primary:{
                        base:"#0d4c75",
                    },
                    secondary:{},
                },
                logo:{
                    url:"https://image.galileo.co.th/go_agencies/Dhakulchan/logo.jpg",
                    aspectRatio:150/70,
                    mobileAspectRatio:2/1,
                    width:150,
                    height:70,
                    mobileWidth:100,
                    mobileHeight:50,  
                    text:"",                    
                }            
            },			
        };
        return themes["w"+wsid];
    },        
};

export default agentTheme;